import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { RootState } from '~/store';
import useTranslate from '~/hooks/useTranslate';
import { GlobalErrorType } from '~/enums';
import useLogout from '~/hooks/useLogout';
import { clearLoanApplicationState } from '~/store/slices/loanApplication.slice';
import { toggleGlobalErrorOff } from '~/store/slices/globalError.slice';
import Popup from '../Popup/Popup';
import ApiFailureError from './components/ApiFailureError';
import TokenExpiredError from './components/TokenExpiredError';
import CustomGlobalError from './components/CustomGlobalError';
import { clearCardApplicationState } from '~/store/slices/cardApplication.slice';

const GlobalErrorPopup = () => {
  const { hasError, errorType, customGlobalError } = useSelector(
    (state: RootState) => state.globalError
  );
  const dispatch = useAppDispatch();
  const translate = useTranslate();
  const logout = useLogout();

  const onOkButtonClick = () => {
    if (errorType === GlobalErrorType.API_FAILURE) {
      dispatch(toggleGlobalErrorOff());
    } else if (errorType === GlobalErrorType.TOKEN_EXPIRED) {
      dispatch(clearLoanApplicationState());
      dispatch(clearCardApplicationState());
      dispatch(toggleGlobalErrorOff());
    } else if (errorType === GlobalErrorType.CUSTOM_ERROR) {
      dispatch(toggleGlobalErrorOff());
    } else {
      logout();
    }
  };

  const buttonTextHandler = () => {
    switch (errorType) {
      case GlobalErrorType.API_FAILURE:
        return translate('Ok');

      case GlobalErrorType.TOKEN_EXPIRED:
        return translate('Onboarding.SessionExpiredButtonText');

      case GlobalErrorType.CUSTOM_ERROR:
        return translate(customGlobalError?.buttonText || 'Ok');

      default:
        return '';
    }
  };

  return (
    <Popup
      buttonText={buttonTextHandler() as string}
      isOpen={hasError}
      onOkButtonClick={onOkButtonClick}
    >
      {errorType === GlobalErrorType.API_FAILURE && <ApiFailureError />}
      {errorType === GlobalErrorType.TOKEN_EXPIRED && <TokenExpiredError />}
      {errorType === GlobalErrorType.CUSTOM_ERROR && customGlobalError && (
        <CustomGlobalError
          title={customGlobalError.title}
          description={customGlobalError?.description}
        />
      )}
    </Popup>
  );
};

export default GlobalErrorPopup;
